import { render, staticRenderFns } from "./TabelaDeItens.vue?vue&type=template&id=1077de5c&scoped=true"
import script from "./TabelaDeItens.vue?vue&type=script&setup=true&lang=js"
export * from "./TabelaDeItens.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TabelaDeItens.vue?vue&type=style&index=0&id=1077de5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1077de5c",
  null
  
)

export default component.exports